<template>
  <div>
    <div v-if="notice.length > 0">
      <ul class="p-4 border-b border-section_border">
        <li v-for="message in notice" :key="message.title" class="course">
          <p class="font-bold text-link_darker">{{ message.title }}</p>
          <div v-if="message.text && message.text.length > 0">
            <p class="text-sm" v-html="message.text"></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Notice',
  mounted () {
    this.$store.dispatch('notice/fetchAll')
  },
  computed: {
    ...mapGetters({
      notice: 'notice/getAll'
    })
  }}
</script>
